import script from "./pendingList.vue?vue&type=script&setup=true&lang=js"
export * from "./pendingList.vue?vue&type=script&setup=true&lang=js"

import "./pendingList.vue?vue&type=style&index=0&id=0b8e11a6&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b8e11a6"]])

export default __exports__